import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_start.jpg';

// page.games = [

// ];
//   {
//     id: 'page016_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 150,
//     },
//   },
//   {
//     id: 'page017_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 300,
//     },
//   },
//   {
//     id: 'page017_game2',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 450,
//     },
//   },
//   {
//     id: 'page018_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 600,
//     },
//   },
//   {
//     id: 'page019_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 750,
//     },
//   },
//   {
//     id: 'page019_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 900,
//     },
//   },
//   {
//     id: 'page020_game2',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1050,
//     },
//   },
//   {
//     id: 'page020_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1200,
//     },
//   },
//   {
//     id: 'page021_game4',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1350,
//     },
//   },
//   {
//     id: 'page022_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1500,
//     },
//   },
//   {
//     id: 'page024_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1650,
//     },
//   },
//   {
//     id: 'page025_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1800,
//     },
//   },
//   {
//     id: 'page026_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 1950,
//     },
//   },
//   {
//     id: 'page027_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2100,
//     },
//   },
//   {
//     id: 'page010_game1',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: RIGHT,
//       y: 2250,
//     },
//   },
// ];
export default page;
